<template>
  <div :class="wrapperClass">
    <label class="flex w-fit items-center gap-2">
      <input
        :id="id"
        ref="input"
        v-bind="$attrs"
        class="sr-only"
        :checked="modelValue"
        :disabled="isDisabled"
        type="checkbox"
        @input="updateValue"
      />
      <span
        class="relative inline-flex h-5 w-9 rounded-full transition-all duration-300 md:h-6 md:w-11"
        :class="[
          {
            'bg-neutral': !modelValue && !isDisabled && !isError,
            'bg-success': modelValue,
            'cursor-not-allowed bg-disabled': isDisabled,
            'bg-error': isError
          },
          inputClass
        ]"
      >
        <span
          class="absolute left-0.5 top-0.5 block h-4 w-4 rounded-full bg-white transition-all duration-300 md:h-5 md:w-5"
          :class="[indicatorClass, modelValue && 'translate-x-full']"
        />
      </span>
      <span
        v-if="isLabelVisible"
        :class="[
          {
            'cursor-pointer': !isDisabled,
            'text-error': isError
          },
          labelClass
        ]"
        >{{ label }}</span
      >
    </label>
  </div>
</template>

<script setup lang="ts">
interface InputProps {
  wrapperClass?: string
  indicatorClass?: string
  inputClass?: string
  label: string
  labelClass?: string
  isLabelVisible?: boolean
  modelValue?: HTMLInputElement['checked']
  isDisabled?: boolean
  isError?: boolean
}

defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<InputProps>(), {
  wrapperClass: 'form-field-toggle',
  indicatorClass: 'form-toggle-indicator',
  inputClass: 'form-toggle',
  labelClass: 'form-toggle-label',
  modelValue: false,
  isDisabled: false,
  isLabelVisible: true,
  isError: false
})

const emit = defineEmits(['update:modelValue', 'change'])

const updateValue = (e: Event) => {
  const checked = (e.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
  emit('change', checked)
}

const id = useId()
</script>
